import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { addStore } from 'client/shared/react-util';
import _ from 'lodash';
import EditImage from '../edit-image';
import { Editor, SongSelector, FieldFactory } from 'client/shared/components';

// Moved this into it's own component so it would stop making the form fields re-rendder and therefore lose thier values
@observer
class SongSelectorContainer extends Component {
	render () {
		const {
			album,
			songList,
			onAddSong,
			onRemoveSong,
			onReorderSongs
		} = this.props;

		return (
			<div className="cell small-12">
				<SongSelector
					addSong={ onAddSong }
					removeSong={ onRemoveSong }
					onDragEnd={ onReorderSongs }
					selectedSongs={ album.songs }
					songList={ songList } />
			</div>
		);
	}
}

// Moved this into it's own component so it would stop making the form fields re-rendder and therefore lose thier values
@inject('albumsStore')
@observer
class EditImageContainer extends Component {
	render () {
		const {
			album,
			albumsStore,
			handleImageCrop
		} = this.props;

		return (
			<div className="cell small-12 medium-4 album-modal album-form-artwork-col">
				<span className="album-form-artwork-heading">Album artwork</span>
				<EditImage
					item={ album }
					store={ albumsStore }
					handleImageCrop={ handleImageCrop }
					imgSrc={ album.artworkPath }
				/>
				<p className="album-form-artwork-hint">
					Click the cover to upload or change artwork (JPG or PNG).
				</p>
			</div>
		);
	}
}


@inject('formStore', 'albumsStore', 'artistStore', 'songsStore', 'userStore')
@observer
class AlbumForm extends Component {
	constructor (props) {
		super(props);

		const { album, artistStore, userStore } = this.props;


		if (_.isEmpty(album.artistID)) {

			let user = userStore.getLoggedInUser();
			let artist = artistStore.loggedInArtist;
			album.artistID = artist.id;
		}
	}

	render () {
		const {
			album,
			albumsStore,
			artistStore,
			userStore,
			formStore,
			handleImageCrop,
			songsStore
		} = this.props;

		let user = userStore.getLoggedInUser();
		let artist = artistStore.loggedInArtist;

		const songList = songsStore.getSongsByArtistID(artist.id);
		const FieldWithStore = addStore(FieldFactory, {
			formStore,
			item: album
		});

		let newAlbum = _.isEmpty(album.id);
		return (
			<div className='grid-container album-form'>
				<h1 className="album-form__title">
					{ newAlbum ? 'Add' : 'Edit' } Album
				</h1>
				<div className="grid-x grid-margin-x album-form__top">
					<div className="cell small-12 medium-8">
						<FieldWithStore fieldKey="album.artistID" />
						<FieldWithStore fieldKey="album.artwork" />
						<FieldWithStore className="profile-field" fieldKey="album.name" />

						<div className="hfm-field">
							<label>Liner Notes</label>
							<Editor
								onChange={ _.debounce(this.onChange, 100) }
								content={ album.linerNotes }
							/>
						</div>
					</div>

					<EditImageContainer album={ album } handleImageCrop={ handleImageCrop } />
				</div>

				<div className="grid-x grid-margin-x album-form__song-section">
					<div className="cell small-12">
						<SongSelectorContainer
							album={ album }
							songList={ songList }
							onAddSong={ this.onAddSongToAlbum }
							onRemoveSong={ this.onRemoveSongFromAlbum }
							onReorderSongs={ this.onReorderAlbumSongs }
						/>
					</div>
					<div className="cell small-12 album-form__actions">
						<button
							type="button"
							onClick={ this.props.submitAction }
							className="button neo mdl"
						>
							Submit
						</button>
						<button
							type="button"
							onClick={ this.props.cancelAction }
							className="button neo mdl"
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onChange (linerNotes) {
		this.props.album.linerNotes = linerNotes;
	}

	@autobind
	onAddSongToAlbum (songId) {
		this.props.album.addSong(songId);
	}

	@autobind
	onRemoveSongFromAlbum (songId) {
		this.props.album.removeSong(songId);
	}

	@autobind
	onReorderAlbumSongs (result) {
		this.props.album.reorderSongs(result);
	}
}

export default AlbumForm;
